import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AbstractNestableOutputComponent } from '../abstract-nestable-output.component';

@Component({
  selector: 'h3-radio-buttons-output',
  templateUrl: './radio-buttons-output.component.html',
  styleUrls: ['./radio-buttons-output.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RadioButtonsOutputComponent extends AbstractNestableOutputComponent {
  constructor(injector: Injector, formBuilder: FormBuilder) {
    super(injector, formBuilder);
  }
}
